import { render, staticRenderFns } from "./CompareProductsModal.vue?vue&type=template&id=a0a051be&scoped=true"
import script from "./CompareProductsModal.vue?vue&type=script&lang=js"
export * from "./CompareProductsModal.vue?vue&type=script&lang=js"
import style0 from "./CompareProductsModal.vue?vue&type=style&index=0&id=a0a051be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a051be",
  null
  
)

export default component.exports